export default "__VITE_ASSET__BdZR9GfN__"